import React from 'react';
import classNames from 'classnames';
import TimeInput from '@zvuk-b2b/react-uikit/ui/TimeInput';
import { InputSize, InputType } from '@zvuk-b2b/react-uikit/ui/Input';
import { TEXTS } from '../../../texts';
import { TIME_PATTERN } from '../../../consts';
import { formatMillisecondsToTime } from '../../../utils';
import { defaultTimeInputWithSecondsValidator } from '../../durationUtils';
import DurationEditHint from '../DurationEditHint';
import type { ImageDurationControlProps } from './types';
import styles from '../index.module.scss';

const ImageDurationControl: React.FC<ImageDurationControlProps> = ({
  elementId,
  helperId,
  playDuration,
  isValid,
  isErrorVisible,
  isBlockedDurationEdit,
  isDisabled,
  onBlur,
  onMouseOut,
  onChange,
}) => (
  <div className={styles.field}>
    <DurationEditHint isBlocked={isBlockedDurationEdit}>
      <TimeInput
        elementId={elementId}
        label={TEXTS.MEDIAFILE_DURATION}
        value={formatMillisecondsToTime(playDuration)}
        inputValidator={defaultTimeInputWithSecondsValidator}
        type={InputType.TEXT}
        size={InputSize.SMALL}
        labelClassName={styles.label}
        containerClassName={styles.control}
        inputClassName={classNames(styles.input, !isValid && styles.invalid)}
        forceError={isErrorVisible}
        aria-invalid={isErrorVisible}
        aria-describedby={helperId}
        isDisabled={isDisabled || isBlockedDurationEdit}
        onBlur={onBlur}
        onMouseOut={onMouseOut}
        onChange={onChange}
        defaultValue={formatMillisecondsToTime(playDuration)}
        pattern={TIME_PATTERN}
        mask={TEXTS.TIME_MASK}
        placeholder={TEXTS.TIME_PLACEHOLDER}
        maxLength={8}
      />
    </DurationEditHint>
    <div
      id={helperId}
      className={classNames(styles.helper, isErrorVisible && styles.error)}>
      {TEXTS.MEDIAFILE_DURATION_HELP}
    </div>
  </div>
);

export default ImageDurationControl;
